const SiteFooter = ({ children }: { children: React.ReactNode }) => {
  return <footer role='contentinfo'>{children}</footer>;
};

export default SiteFooter;
